import React, { useState } from "react";
import {
  Navbar,
  NavbarBrand,
  NavbarContent,
  NavbarItem,
  NavbarMenuToggle,
  NavbarMenu,
  NavbarMenuItem,
  Link,
} from "@heroui/react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  useDisclosure,
} from "@heroui/react";
import { CompanyLogo } from "./companyLogo";
import { useLocation } from "react-router-dom";

const NavigationBar = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const backdrop = React.useState("blur");

  const menuItems = [
    { label: "Home", route: "/home" },
    { label: "Therapeutics", route: "/therapeutics" },
    { label: "Precision-Care", isModal: true },
    { label: "Team", route: "/team" },
    { label: "Contact Us", route: "/contactus" },
  ];

  return (
    <>
      <Navbar
        shouldHideOnScroll
        onMenuOpenChange={setIsMenuOpen}
        isBordered={true}
        maxWidth="full"
        className=" bg-white font-proxima-nova font-thin"
      >
        <NavbarContent className="sm:hidden" justify="start">
          <NavbarMenuToggle
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
            className="sm:hidden"
          />
          <NavbarBrand>
            <Link href="/home" className="text-black hover:text-black gap-4">
              <CompanyLogo width="40" height="40" />
              <p className="tracking-widest custom-font text-lg text-black uppercase">
                Flahy
              </p>
            </Link>
          </NavbarBrand>
        </NavbarContent>
        {/* <NavbarContent className="sm:hidden" justify="left">
        <NavbarBrand>
          <Link href="/home" className="text-black hover:text-black gap-4">
            <CompanyLogo width="40" height="40" />
            <p className="tracking-widest custom-font text-lg text-black uppercase">
              Flahybase
            </p>
          </Link>
        </NavbarBrand>
      </NavbarContent> */}
        <NavbarContent className="hidden sm:flex gap-10" justify="end">
          <NavbarBrand className="gap-4">
            <Link href="/home" className="text-black hover:text-black gap-4">
              <CompanyLogo width="40" height="40" />
              <p className="tracking-widest custom-font text-lg text-black uppercase">
                Flahy
              </p>
            </Link>
          </NavbarBrand>
          <NavbarItem>
            <Link
              className={`text-black hover:text-black ${
                location.pathname === "/home" || location.pathname === "/"
                  ? " border-black border-b-1 pb-1 pt-1"
                  : "border-white border-b-1 pb-1 pt-1"
              }`}
              href="/home"
            >
              Home
            </Link>
          </NavbarItem>
          <NavbarItem>
            <Link
              className={`text-black hover:text-black ${
                location.pathname === "/therapeutics"
                  ? " border-black border-b-1 pb-1 pt-1"
                  : "border-white border-b-1 pb-1 pt-1"
              }`}
              href="/therapeutics"
            >
              Therapeutics
            </Link>
          </NavbarItem>
          <NavbarItem>
            {/* <Link
              className={`text-black hover:text-black `}
              href="https://flahyrecovery.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Precision-Medicine
            </Link> */}
            <Link
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onOpen();
              }}
              className="text-black hover:text-black border-white border-b-1 pb-1 pt-1"
            >
              Precision-Care
            </Link>
          </NavbarItem>

          <NavbarItem>
            <Link
              className={`text-black hover:text-black ${
                location.pathname === "/team"
                  ? " border-black border-b-1 pb-1 pt-1"
                  : "border-white border-b-1 pb-1 pt-1"
              }`}
              href="/team"
            >
              Team
            </Link>
          </NavbarItem>
          {/* <NavbarItem>
          <Link
            className={`text-black hover:text-black ${
              location.pathname === "/clinics"
                ? " border-black border-b-1 pb-1 pt-1"
                : "border-white border-b-1 pb-1 pt-1"
            }`}
            href="/clinics"
          >
            For Clinics
          </Link>
        </NavbarItem> */}
          <NavbarItem>
            <Link
              href="/contactus"
              className="text-white hover:text-white bg-black p-2 rounded-md"
              aria-current="page"
            >
              Contact Us
            </Link>
          </NavbarItem>
        </NavbarContent>
        {/* <NavbarContent className="gap-4 invisible" justify="end">
        <NavbarItem className=" lg:flex">
          <Link href="#" className="text-black">
            Login
          </Link>
        </NavbarItem>
        <NavbarItem>
          <Button as={Link} color="default" href="#" variant="flat">
            <span className="text-black">Sign Up</span>
          </Button>
        </NavbarItem>
      </NavbarContent> */}
        <NavbarMenu className="bg-white">
          {menuItems.map((menuItem, index) => (
            <NavbarMenuItem key={index}>
              {menuItem.isModal ? (
                <Link
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    onOpen();
                  }}
                  className="text-black hover:text-black border-white border-b-1 pb-1 pt-1"
                >
                  {menuItem.label}
                </Link>
              ) : (
                <Link
                  href={menuItem.route}
                  className={`text-black hover:text-black ${
                    location.pathname === menuItem.route
                      ? "border-black border-b-1 pb-1 pt-1"
                      : "border-white border-b-1 pb-1 pt-1"
                  }`}
                >
                  {menuItem.label}
                </Link>
              )}
            </NavbarMenuItem>
          ))}
        </NavbarMenu>
      </Navbar>
      <Modal
        backdrop={"blur"}
        isOpen={isOpen}
        onClose={onClose}
        hideCloseButton={false}
        placement="center"
      >
        <ModalContent className="w-[90%] sm:w-[50%] max-w-sm max-h-[90vh] overflow-y-auto rounded-xl">
          {(onClose) => (
            <>
              <ModalBody className="justify-center items-center">
                <ModalHeader className="font-proxima-nova pb-0">
                  Select Care Area
                </ModalHeader>
                <Link
                  className="font-proxima-nova pt-4 text-center text-black hover:text-slate-700 cursor-pointer underline"
                  href="https://flahyrecovery.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Oncology
                </Link>
                <Link
                  className="font-proxima-nova pt-4 pb-10 text-center text-black hover:text-slate-700 cursor-pointer underline"
                  href="https://flahyrecovery.com/en/neuro-psych"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Neurology & Psychiatry
                </Link>
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default NavigationBar;
